import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { of } from 'rxjs';
import { schoolPsychologyService } from '../../../common/services';


export function saveSchoolPsychologyRequest(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST),
    mergeMap(({ payload }) => {
      return schoolPsychologyService.saveSchoolPsychologyRequest(payload).pipe(
        map((res) => actions.saveSchoolPsychologyRequestSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.SAVE_SCHOOL_PSYCHOLOGY_REQUEST_FAIL,
            payload: error,
            error: true
          })
          // console.log("error...........")
        )
      )
    })
  )
}

export function getSchoolPsychologyRequest(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST),
    mergeMap(({ payload }) => {
      return schoolPsychologyService.getSchoolPsychologyRequest(payload).pipe(
        map((res) => actions.getSchoolPsychologyRequestSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.GET_SCHOOL_PSYCHOLOGY_REQUEST_FAIL,
            payload: error,
            error: true
          }))
      )
    })
  )
}
